import PraguePlugin from './plugin/PraguePlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule, LazyImport } from 'owa-bundling';
import { PluginEventType } from 'roosterjs-editor-types';
import { default as isPragueEnabled, PragueEnabledScenario } from './utils/isPragueEnabled';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Prague" */ './lazyIndex'));

export type LazyPraguePlugin = LazyPlugin<PraguePlugin>;

export let LazyPraguePluginClass = createLazyPlugin(
    lazyModule,
    m => m.PraguePlugin,
    'Prague',
    event => event.eventType == PluginEventType.EditorReady
);

export let lazyMountBohemiaComponent = new LazyImport(lazyModule, m => m.mountBohemiaComponent);

export let lazyTryGetBohemiaDriverForUrl = new LazyImport(
    lazyModule,
    m => m.tryGetBohemiaDriverForUrl
);

// Exports
export { LazyPlugin, isPragueEnabled, PragueEnabledScenario };
